<template>
  <section>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
        <ul>
          <li class="formList">
            <dl>
              <dd>
                <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="param.searchGroup"
                          dense
                          clearable
                          flat
                          outlined
                          label="분과"
                          v-on:change="search"/>
              </dd>
            </dl>
            <dl>
              <dd>
                <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="param.searchGroup"
                          dense
                          clearable
                          flat
                          outlined
                          label="동호회"
                          v-on:change="search"/>
              </dd>
            </dl>

            <dl>
              <dd>
                <date-range-component v-on:event="getSearchDate" label="모임일"
                                      :value="param.searchDate"></date-range-component>
              </dd>
              <dd>
                <div class="monthBx">
                  <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                          :class="{ active: month === activeItem}"
                          @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                  </button>
                </div>
              </dd>
            </dl>
            <dl>
              <dd>
                <v-col sm="6">
                  <v-text-field label="제목 / 장소 / 주소 검색"
                                v-model="param.searchKeyword" v-on:keyup.enter="search"
                                dense clearable flat outlined/>
                </v-col>
              </dd>
            </dl>

          </li>
        </ul>
      </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
          <v-checkbox class="mgr" label="" v-model="all" :true-value="true" :false-value="false"/>
          검색 된 총 <span class="txtPoint">{{ totalItems }}건</span> 선택
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn color="grey" depressed dark @click="deleteJoin()">삭제</v-btn>
            </li>
          </ul>
        </div>
      </div>

      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="dataset"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="meetingId"
            class="elevation-1"
        >
          <template v-slot:item.idx="{item}">
            {{item.idx}}
          </template>
          <template v-slot:item.groupName="{value, item}">
            {{item.parentGroupName}} > {{ value }}
          </template>

          <template v-slot:item.amount="{value}">
            {{ value | numeralFormat('0,000')}}
          </template>

          <template v-slot:item.startDt="{ value, item }">
            {{ value | moment('YYYY-MM-DD') }} ~ {{ item.endDt | moment('YYYY-MM-DD') }}
          </template>

          <template v-slot:item.joinDt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.state="{item}">
            {{ joinState(item) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                @click.stop="deleteJoin(item)"
            >
              mdi-delete
            </v-icon>
          </template>

        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent"
import meetingApi from '@/api/UserMeetingApi'
import groupApi from "@/api/GroupApi";

export default {
  name: "MeetingList",
  components: {
    'date-range-component': DateRageComponent
  },
  props: {
    userId: String
  },
  data: () => ({
    date: new Date(),
    menu: false,
    menu2: false,
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    selected: [],
    headers: [
      {text: 'No', value: 'idx', sortable: false},
      {text: '카테고리', value: 'groupName', sortable: false},
      {text: '제목', value: 'title', sortable: false},
      {text: '장소명', value: 'place', sortable: false},
      {text: '기간', value: 'startDt', sortable: false},
      {text: '신청일', value: 'joinDt', sortable: false},
      {text: '가족동반', value: 'familyCount', sortable: false},
      {text: '참석여부', value: 'state', sortable: false},
      {text: '관리', value: 'actions', sortable: false},
    ],
    param: {
      searchDate:[],
      searchGroup:null,
      fromJoin: null,
      toJoin: null,
      page: 1
    },
    options:{},
    dataset: [],
    totalItems: 0,
    dialogVisible: false,
    waitingSearch: false,
    searchValue: null,
    departmentItems:[],
    clubItems:[],
    rules: {
      required: value => !!(value || value === false || value === true) || '필수 입력 항목입니다..'
    },
    meetingTitle:'',
    all: false,
    amountItems: [
      {value: 10000, text: '1만'}, {value: 30000, text: '3만'}, {value: 50000, text: '5만'},
      {value: 100000, text: '10만'}, {value: 0, text: '직접입력'}],
    activeAmount:0,
    cal: false,
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  methods: {
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    joinState(item) {

      if(this.$moment().diff(item.startDt, 'day') < 0)
        return "참석예정"
      if(this.$moment().diff(item.endDt, 'day') > 0)
        return "완료"
      if(item.deposited)
        return "입금완료"
      else
        return "입금예정"

    },
    search() {
      const {  page, itemsPerPage, size } = this.options;
      const params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.activeItem > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      meetingApi.list(this.userId, params).then(data => {
        this.totalItems = data.totalElements;
        this.dataset = data.content.map((d, i) => {
          d.idx = this.totalItems - i - (( (data.pageable.offset+1) - 1) * data.pageable.pageSize);
          return d;
        });
        // console.log(data);
      });
    },
    deleteJoin(meeting) {
      if(confirm("삭제하시겠습니까?")) {
        meetingApi.delete(this.userId, meeting.meetingId).then(() => {
          this.search();
        });
      }
    },
  },
  created: function () {
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    //width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
.amountBx {
  display: flex;
  align-items: center;
  height: 35px;
  border-radius: 3px;
  border: 1px solid #1867c0;
  margin-top: 13px;

  .amount {
    &:first-child {
      padding-left: 10px;
    }

    height: 100%;
    padding: 0 8px;
    border: 0;
    background: #fff;
    font-size: 13px;
    font-weight: normal;
    color: #1867c0;

    &.active {
      background: #1867c0;
      color: #fff;
    }
  }
}
</style>